import React from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import ProduttivoMuiThemeV2 from '@/components/shared/themes/ProduttivoThemeV2'
import WorkUserMaps from '@/javascript/presentation/pages/work_team_maps/work-user-maps'
import {
  makeRemoteLoadAccountMemberList, makeRemoteLoadFormList, makeRemoteLoadProjectList, makeRemoteLoadResourcePlaceList,
  makeRemoteLoadUserLocationList, makeRemoteLoadWorkFinishOptionList, makeRemoteLoadWorkLocationList, makeRemoteLoadRouteList,
  makeRemoteDeleteRoute
} from '@/javascript/main/factories/usecases'

const mapsEl = document.getElementById('work-team-maps-root')


export const makeWorkUserMaps = () => {
  const hasCreateRoute= mapsEl.getAttribute('data-can-create-route') === 'true'
  const isWorkTeamRoutingEnabled = mapsEl?.getAttribute('data-work-team-routing') === 'true'

  return(
    <ThemeProvider theme={ProduttivoMuiThemeV2}>
      <WorkUserMaps
        loadAccountMemberList={makeRemoteLoadAccountMemberList()}
        loadFormList={makeRemoteLoadFormList()}
        loadProjectList={makeRemoteLoadProjectList()}
        loadResourcePlaces={makeRemoteLoadResourcePlaceList()}
        loadWorkFinishOptionList={makeRemoteLoadWorkFinishOptionList()}
        loadUserLocationList={makeRemoteLoadUserLocationList()}
        loadWorkLocationList={makeRemoteLoadWorkLocationList()}
        loadRouteList={makeRemoteLoadRouteList()}
        deleteRoute={makeRemoteDeleteRoute()}
        canCreateRoute={hasCreateRoute}
        isWorkTeamRoutingEnabled={isWorkTeamRoutingEnabled}
      />
    </ThemeProvider>
  )
}

if (mapsEl !== null) {
  const root = createRoot(mapsEl)
  root.render(makeWorkUserMaps())
}
